import fetchSettings from '../Services/fetchSettings'
import { setFilters } from '../State/filters'

export default () => (dispatch, getState) => {

  // Check for URL parameters to set initial filters
  const urlParams = new URLSearchParams(window.location.search)
  const groupParam = urlParams.get('group')
  
  if (groupParam) {
    // Set the group filter from URL parameter
    dispatch(setFilters({ group: groupParam }))
  }

  dispatch(fetchSettings())
  
}
